import OperationalReportPage from "./OperationalReportPage";
export default function SizeSellThroughReportPage() {
  return <OperationalReportPage kind="size-sell-through" />;
}
